import React, { useState } from 'react';
import './ClientCarousel.scss';

const ClientCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const clients = [
    { name: 'The AutoParts Shop', logo: 'autoparts-logo.svg' },
    { name: 'ITech', logo: 'itech-logo.svg' },
    { name: 'Insure your company.com', logo: 'insure-logo.svg' },
    { name: 'Synergy Chicago', logo: 'synergy-logo.svg' },
    { name: 'ENGLEWOOD HEALTH', logo: 'englewood-logo.svg' },
    { name: 'WESTERN UNION', logo: 'western-union-logo.svg' },
    { name: 'IIE', logo: 'iie-logo.svg' },
    { name: 'OnBlick', logo: 'onblick-logo.svg' },
    { name: 'OnlineVisas', logo: 'onlinevisas-logo.svg' },
  ];

  const handlePrev = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === 0 ? clients.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === clients.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <section className="client-carousel section">
      <div className="container">
        <h2 className="client-carousel__title">OUR CLIENTS</h2>
        <div className="client-carousel__wrapper">
          <button 
            className="client-carousel__nav client-carousel__nav--prev"
            onClick={handlePrev}
            aria-label="Previous client"
          >
            {/* Chevron left icon */}
          </button>

          <div className="client-carousel__content">
            {clients.map((client, index) => (
              <div
                key={client.name}
                className={`client-carousel__item ${
                  index === currentIndex ? 'active' : ''
                }`}
              >
                <div className="client-carousel__logo-placeholder">
                  {client.name}
                </div>
              </div>
            ))}
          </div>

          <button 
            className="client-carousel__nav client-carousel__nav--next"
            onClick={handleNext}
            aria-label="Next client"
          >
            {/* Chevron right icon */}
          </button>
        </div>
      </div>
    </section>
  );
};

export default ClientCarousel; 
